<section class="flex flex-col min-h-screen">
  <main *ngIf="isUnauthorized" class="layout-unauthorized">
    <app-unauthorized-access></app-unauthorized-access>
  </main>

  <!-- REVERSE ngIf WHEN FINISHED -->
  <main *ngIf="!isUnauthorized" class="layout-error">
    <div class="layout-error__wrapper container">
      <div class="layout-error__container">
        <!-- Header -->
        <header class="layout-error__header">
          <!-- Title -->
          <h1 class="layout-error__title title-1">
            {{ 'error.404.title' | translate }}
          </h1>

          <!-- Subtitle -->
          <h2 class="layout-error__subtitle title-2">
            {{ 'error.404.subtitle' | translate }}
          </h2>
        </header>

        <div class="layout-error__content">
          <!-- CTA -->
          <a
            app-vtmn-play-button
            [variant]="vtmnPlayButtonVariant.PRIMARY"
            [style]="vtmnPlayButtonStyle.INVERSE"
            [shape]="vtmnPlayButtonShape.SQUARED"
            [href]="'/'"
          >
            {{ 'error.404.back_home' | translate }}
          </a>
        </div>
      </div>
    </div>
  </main>
</section>
